import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/break-even.svg";
var BreakEvenOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BreakEvenOutline_default as default
};
